import React from 'react';
import { useParams } from 'react-router-dom';
import BlogLayout from '../../components/BlogLayout/BlogLayout';
import ColdWalletSetup from './posts/ColdWalletSetup';

// Blog post metadata
const blogPosts = [
  {
    id: 'how-to-setup-cold-wallet-for-chia-xch',
    title: 'How to Set Up a Cold Wallet for Chia (XCH) - Part 1',
    subtitle: 'Understanding Cold Wallets',
    date: 'March 15, 2024',
    category: 'Guides',
    component: ColdWalletSetup,
    description: 'Learn how to create and secure a cold wallet for your Chia (XCH) assets. Part 1 of our comprehensive cold wallet series covers the fundamentals and preparation steps.',
    series: 'Cold Wallet Setup Guide'
  }
  // Add more blog posts here
];

const Blog: React.FC = () => {
  const { blogId } = useParams();
  const currentPostId = blogId || blogPosts[0].id;
  const currentPost = blogPosts.find(post => post.id === currentPostId);
  const PostComponent = currentPost?.component || blogPosts[0].component;

  return (
    <BlogLayout 
      posts={blogPosts}
      selectedPostId={currentPostId}
    >
      <PostComponent />
    </BlogLayout>
  );
};

export default Blog; 